<template lang="pug">
    .columns.is-vcentered.is-mobile
      .container.has-text-centered
        .columns.is-centered
          .column.is-one-third
            h1 {{$t('componentes.coletor.views.confirmacaoInfoColetor.titulo')}}?
        .columns.is-centered
          .column.is-half
            InputText(
              v-model.trim="nomeColetor"
              :podeEditar="true"
              @habilitarEdicao="habilitarEdicaoNome"
              :label="$t('componentes.coletor.views.confirmacaoInfoColetor.labelNomeDoColetor')"
              :required="true"
              :disabled="naoPermitEdicaoNome"
              )
        .columns.is-centered(v-if="mostraLocais && coletor")
          .column.is-half
              MultiSeletor(
                :label="$t('componentes.coletor.views.confirmacaoInfoColetor.labelLocaisDeTrabalho')"
                :podeEditar="true"
                @habilitarEdicao="habilitarEdicaoLocais"
                :items="coletor"
                itemRef="nome"
                @checkedValues="coletaLocais"
                :allChecked="true"
                :disabled="naoPermitEdicaoLocais"
                :allowLoadMoreItens="!naoPermitEdicaoLocais"
                :allowedExtraItens="todosLocaisDeTrabalho"
                :allowFilter="!naoPermitEdicaoLocais"
                filterLabel="Buscar locais de trabalho"
                @parametroBusca="buscarMaisLocais"
                )
        .columns.is-centered
          .column.is-one-quarter
            Button3d( color="success" size="medium" :block="true" @click="executarColetor") {{$t('componentes.coletor.views.confirmacaoInfoColetor.botaoSim')}}
          .column.is-one-quarter
            Button3d( color="info" size="medium" :block="true" @click="voltar") {{$t('componentes.coletor.views.confirmacaoInfoColetor.botaoVoltar')}}
</template>

<script>
import MultiSeletor from '@/common/Seletores/MultiSeletor.vue'
import { validarCamposCriarColetor, validarCamposRestaurarColetor } from '../utils'
export default {
  name: 'ConfirmacaoInfoColetor',
  components: { MultiSeletor },
  created () {
    const ehFuncionario = this.$store.state.coletor.criarColetor.ehFuncionario
    const ehCadastroIndividual = Boolean(this.$store.state.coletor.criarColetor.modo === 'individual')
    const ehParaTodosOsLocais = Boolean(this.$store.state.coletor.criarColetor.modo === 'todos')
    const nomeRotaAnterior = this.$store.state.rotaAnterior.name
    if (nomeRotaAnterior === 'listaColetores') {
      this.veioDeListaColetores = true
    } else {
      this.veioDeCriarColetor = true
    }
    if (nomeRotaAnterior === 'criarColetor' && (ehFuncionario || ehCadastroIndividual || ehParaTodosOsLocais)) {
      this.mostraLocais = false
    }
  },
  data () {
    return {
      locaisSelecionados: [],
      naoPermitEdicaoLocais: true,
      naoPermitEdicaoNome: true,
      veioDeListaColetores: null,
      veioDeCriarColetor: null,
      mostraLocais: true
    }
  },
  computed: {
    coletor: {
      get () {
        if (this.veioDeListaColetores) {
          return this.$store.state.coletor.restaurarColetor.locais
        }
        return this.$store.state.coletor.criarColetor.locais.selecionado
      }
    },
    nomeColetor: {
      get () {
        if (this.veioDeListaColetores) {
          return this.$store.state.coletor.restaurarColetor.nome
        }
        return this.$store.state.coletor.criarColetor.nome
      },
      set (value) {
        if (this.veioDeListaColetores) {
          this.$store.commit('coletor/atribuiNomeRestaurarColetor', value)
          return
        }
        this.$store.commit('coletor/atribuiNomeCriarColetor', value)
      }
    },
    todosLocaisDeTrabalho () {
      return this.$store.getters['coletor/locaisDeTrabalhoIdENome']
    }
  },
  methods: {
    coletaLocais (event) {
      if (this.veioDeListaColetores) {
        this.$store.commit('coletor/atribuiLocaisRestaurarColetor', event)
        return
      }
      if (this.veioDeCriarColetor) {
        this.$store.commit('coletor/atribuiLocaisCriarColetor', { selecionado: event })
      }
    },
    voltar () {
      if (this.veioDeListaColetores) {
        this.$router.push({ name: 'listaColetores' })
        return
      }
      this.$router.push({ name: 'criarColetor' })
    },
    executarColetor () {
      if (this.veioDeCriarColetor) {
        const temErro = validarCamposCriarColetor()
        const ehFuncionario = this.$store.state.coletor.criarColetor.ehFuncionario
        const ehCadastroIndividual = Boolean(this.$store.state.coletor.criarColetor.modo === 'individual')

        if (temErro) return

        if (ehFuncionario || ehCadastroIndividual) {
          this.$store.dispatch('coletor/criarColetorPessoal')
        } else {
          this.$store.dispatch('coletor/criarColetorColetivo')
        }
        return
      }
      const temErro = validarCamposRestaurarColetor()

      if (temErro) return
      this.$store.dispatch('coletor/restaurarColetor')
    },
    habilitarEdicaoLocais () {
      this.naoPermitEdicaoLocais = !this.naoPermitEdicaoLocais
    },
    habilitarEdicaoNome () {
      this.naoPermitEdicaoNome = !this.naoPermitEdicaoNome
    },
    buscarMaisLocais () {
      this.$store.dispatch('coletor/buscarLocaisDeTrabalho')
    }
  }
}
</script>
